import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["link"];

  connect() {
    this.element.addEventListener(
      "show.bs.modal",
      this.handleModalShow.bind(this),
    );
  }

  disconnect() {
    this.element.removeEventListener(
      "show.bs.modal",
      this.handleModalShow.bind(this),
    );
  }

  handleModalShow(event) {
    const url = event.relatedTarget?.dataset?.contextualLinkUrlParam;
    if (!url) {
      console.error("No URL provided");
      event.preventDefault();
      return;
    }
    const form = this.linkTarget.form;
    form.action = url;
  }
}
